/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/
import * as datastoreCollections from '@freelancer/datastore/collections';
import * as documentCreators from './document-creators';
import * as pushTransformers from './push-transformers';

export const datastoreFunctions = {
  abnDetailsBackend: datastoreCollections.abnDetailsBackend,
  accountProgressEmailVerify: datastoreCollections.accountProgressEmailVerify,
  accountProgressPaymentVerify:
    datastoreCollections.accountProgressPaymentVerify,
  getActiveLanguages: datastoreCollections.getActiveLanguages,
  facebookAdminEnterprise: datastoreCollections.facebookAdminEnterprise,
  freightlancerAdminEnterprise:
    datastoreCollections.freightlancerAdminEnterprise,
  nasaAdminEnterprise: datastoreCollections.nasaAdminEnterprise,
  techMahindraAdminEnterprise: datastoreCollections.techMahindraAdminEnterprise,
  projectContext: datastoreCollections.projectContext,
  freelancerAdminPool: datastoreCollections.freelancerAdminPool,
  deloitteAdminPool: datastoreCollections.deloitteAdminPool,
  facebookAdminPool: datastoreCollections.facebookAdminPool,
  talentNetworkAdminPool: datastoreCollections.talentNetworkAdminPool,
  anotherTalentNetworkAdminPool:
    datastoreCollections.anotherTalentNetworkAdminPool,
  adminProfileHistoryBackend: datastoreCollections.adminProfileHistoryBackend,
  adminProfileHistoryReducer: datastoreCollections.adminProfileHistoryReducer,
  adminProjectsBackend: datastoreCollections.adminProjectsBackend,
  adminProjectsReducer: datastoreCollections.adminProjectsReducer,
  withUserSourceType: datastoreCollections.withUserSourceType,
  withProjectSourceType: datastoreCollections.withProjectSourceType,
  withContestSourceType: datastoreCollections.withContestSourceType,
  withInvoiceSourceType: datastoreCollections.withInvoiceSourceType,
  withOffsiteSourceType: datastoreCollections.withOffsiteSourceType,
  withTransactionSourceType: datastoreCollections.withTransactionSourceType,
  withTicketSourceType: datastoreCollections.withTicketSourceType,
  withLocalJobSupportType: datastoreCollections.withLocalJobSupportType,
  withRecruiterSupportType: datastoreCollections.withRecruiterSupportType,
  withFreightlancerSupportType:
    datastoreCollections.withFreightlancerSupportType,
  withLoadshiftMarketplaceSupportType:
    datastoreCollections.withLoadshiftMarketplaceSupportType,
  withEqaSupportType: datastoreCollections.withEqaSupportType,
  withProjectQualityAuditSupportType:
    datastoreCollections.withProjectQualityAuditSupportType,
  withProjectManagementSupportType:
    datastoreCollections.withProjectManagementSupportType,
  withSuccessManagerSupportType:
    datastoreCollections.withSuccessManagerSupportType,
  withFreelancerVerifiedSupportType:
    datastoreCollections.withFreelancerVerifiedSupportType,
  withPjpAssistantSupportType: datastoreCollections.withPjpAssistantSupportType,
  withDiscoverSupportType: datastoreCollections.withDiscoverSupportType,
  withExperFreelancerScreeningSupportType:
    datastoreCollections.withExperFreelancerScreeningSupportType,
  withGeneralSupportType: datastoreCollections.withGeneralSupportType,
  withMembershipCurationSupportType:
    datastoreCollections.withMembershipCurationSupportType,
  withProfilePictureCurationSupportType:
    datastoreCollections.withProfilePictureCurationSupportType,
  withDepositFailureSupportType:
    datastoreCollections.withDepositFailureSupportType,
  withOffsiteSupportType: datastoreCollections.withOffsiteSupportType,
  withPaymentSatisfactionSupportType:
    datastoreCollections.withPaymentSatisfactionSupportType,
  withPfpTicketsSupportType: datastoreCollections.withPfpTicketsSupportType,
  withHpIncomingProjectSupportType:
    datastoreCollections.withHpIncomingProjectSupportType,
  withHpAwaitingDeliverySupportType:
    datastoreCollections.withHpAwaitingDeliverySupportType,
  withHpReviewSupportType: datastoreCollections.withHpReviewSupportType,
  withHpProgressBlockedSupportType:
    datastoreCollections.withHpProgressBlockedSupportType,
  withHpReviewFailuresSupportType:
    datastoreCollections.withHpReviewFailuresSupportType,
  withFreightlancerConciergeContext:
    datastoreCollections.withFreightlancerConciergeContext,
  projectsPostedMetric: datastoreCollections.projectsPostedMetric,
  projectsAwardedMetric: datastoreCollections.projectsAwardedMetric,
  externalProjectsAwardedMetric:
    datastoreCollections.externalProjectsAwardedMetric,
  projectsUnawardedMetric: datastoreCollections.projectsUnawardedMetric,
  medianBidCountMetric: datastoreCollections.medianBidCountMetric,
  spendOverTimeMetric: datastoreCollections.spendOverTimeMetric,
  spendOverTimeCumulativeSumMetric:
    datastoreCollections.spendOverTimeCumulativeSumMetric,
  meanBidAmountMetric: datastoreCollections.meanBidAmountMetric,
  medianBidAmountMetric: datastoreCollections.medianBidAmountMetric,
  usersActiveMetric: datastoreCollections.usersActiveMetric,
  hoursPostedMetric: datastoreCollections.hoursPostedMetric,
  hoursPostedCumulativeSumMetric:
    datastoreCollections.hoursPostedCumulativeSumMetric,
  averageTimeToAwardMetric: datastoreCollections.averageTimeToAwardMetric,
  talentSkillsMetric: datastoreCollections.talentSkillsMetric,
  internalUserSkillsMetric: datastoreCollections.internalUserSkillsMetric,
  projectSkillsMetric: datastoreCollections.projectSkillsMetric,
  billableMetric: datastoreCollections.billableMetric,
  audienceInternalOnly: datastoreCollections.audienceInternalOnly,
  audienceExternal: datastoreCollections.audienceExternal,
  npsiScoreMetric: datastoreCollections.npsiScoreMetric,
  isAppPlatformType: datastoreCollections.isAppPlatformType,
  deloitteBidRestriction: datastoreCollections.deloitteBidRestriction,
  sessionToBidSummariesTransformer:
    datastoreCollections.sessionToBidSummariesTransformer,
  awardedBid: datastoreCollections.awardedBid,
  acceptedBid: datastoreCollections.acceptedBid,
  canceledBid: datastoreCollections.canceledBid,
  rejectedBid: datastoreCollections.rejectedBid,
  revokedBid: datastoreCollections.revokedBid,
  partlyPaidCompleteBid: datastoreCollections.partlyPaidCompleteBid,
  fullyPaidCompleteBid: datastoreCollections.fullyPaidCompleteBid,
  incompleteBid: datastoreCollections.incompleteBid,
  pendingBid: datastoreCollections.pendingBid,
  bidsFromProject: datastoreCollections.bidsFromProject,
  businessBuilderAttemptBackend:
    datastoreCollections.businessBuilderAttemptBackend,
  businessBuilderRandomIdeasBackend:
    datastoreCollections.businessBuilderRandomIdeasBackend,
  businessBuilderTemplateBackend:
    datastoreCollections.businessBuilderTemplateBackend,
  campaignsBackend: datastoreCollections.campaignsBackend,
  canViewEmployerProfileFromUser:
    datastoreCollections.canViewEmployerProfileFromUser,
  cartItemFromMilestoneDraft: datastoreCollections.cartItemFromMilestoneDraft,
  cartForProject: datastoreCollections.cartForProject,
  phpCategoryPage: datastoreCollections.phpCategoryPage,
  isChallengeContestElement: datastoreCollections.isChallengeContestElement,
  isChallengeElement: datastoreCollections.isChallengeElement,
  isChallengeUiPropertyTypeApi:
    datastoreCollections.isChallengeUiPropertyTypeApi,
  withContestChallengeElement: datastoreCollections.withContestChallengeElement,
  withUnlinkedChallengeElement:
    datastoreCollections.withUnlinkedChallengeElement,
  forEnterprise: datastoreCollections.forEnterprise,
  bidsDigestEmailSubject: datastoreCollections.bidsDigestEmailSubject,
  bidsDigestEmailBody: datastoreCollections.bidsDigestEmailBody,
  wonEmailSubject: datastoreCollections.wonEmailSubject,
  wonEmailBody: datastoreCollections.wonEmailBody,
  collaborationInvitationEmailSubject:
    datastoreCollections.collaborationInvitationEmailSubject,
  collaborationInvitationEmailBody:
    datastoreCollections.collaborationInvitationEmailBody,
  reminderUserToComeBackEmailSubject:
    datastoreCollections.reminderUserToComeBackEmailSubject,
  reminderUserToComeBackEmailBody:
    datastoreCollections.reminderUserToComeBackEmailBody,
  fundingRequiredEmailSubject: datastoreCollections.fundingRequiredEmailSubject,
  fundingRequiredEmailBody: datastoreCollections.fundingRequiredEmailBody,
  ppmdEmailSubject: datastoreCollections.ppmdEmailSubject,
  ppmdEmailBody: datastoreCollections.ppmdEmailBody,
  complianceQueueAgentDigestEmailSubject:
    datastoreCollections.complianceQueueAgentDigestEmailSubject,
  complianceQueueAgentDigestEmailBody:
    datastoreCollections.complianceQueueAgentDigestEmailBody,
  colleagueAwardedProjectEmailSubject:
    datastoreCollections.colleagueAwardedProjectEmailSubject,
  colleagueAwardedProjectEmailBody:
    datastoreCollections.colleagueAwardedProjectEmailBody,
  pjpSubheader: datastoreCollections.pjpSubheader,
  preapprovedRepostPjpSubheader:
    datastoreCollections.preapprovedRepostPjpSubheader,
  rejectedRepostPjpSubheader: datastoreCollections.rejectedRepostPjpSubheader,
  annotationContestComment: datastoreCollections.annotationContestComment,
  activeEntry: datastoreCollections.activeEntry,
  awardedEntry: datastoreCollections.awardedEntry,
  boughtEntry: datastoreCollections.boughtEntry,
  deletedEntry: datastoreCollections.deletedEntry,
  draftEntry: datastoreCollections.draftEntry,
  rejectedEntry: datastoreCollections.rejectedEntry,
  withdrawnEntry: datastoreCollections.withdrawnEntry,
  withdrawnEliminatedEntry: datastoreCollections.withdrawnEliminatedEntry,
  pendingEntry: datastoreCollections.pendingEntry,
  sealedEntry: datastoreCollections.sealedEntry,
  highlightEntry: datastoreCollections.highlightEntry,
  memberFee: datastoreCollections.memberFee,
  topFreelancerFee: datastoreCollections.topFreelancerFee,
  memberFeeExhausted: datastoreCollections.memberFeeExhausted,
  videoContestFile: datastoreCollections.videoContestFile,
  imageContestFile: datastoreCollections.imageContestFile,
  documentContestFile: datastoreCollections.documentContestFile,
  unrecognizedContestFile: datastoreCollections.unrecognizedContestFile,
  handoverEntryAwarded: datastoreCollections.handoverEntryAwarded,
  handoverAwaitingFreelancerSignature:
    datastoreCollections.handoverAwaitingFreelancerSignature,
  handoverAwaitingBuyerSignature:
    datastoreCollections.handoverAwaitingBuyerSignature,
  handoverAwaitingFreelancerUpload:
    datastoreCollections.handoverAwaitingFreelancerUpload,
  handoverAwaitingBuyerConfirmation:
    datastoreCollections.handoverAwaitingBuyerConfirmation,
  handoverBothConfirmed: datastoreCollections.handoverBothConfirmed,
  completeHandoverByClient: datastoreCollections.completeHandoverByClient,
  completeHandoverByFreelancer:
    datastoreCollections.completeHandoverByFreelancer,
  handoverWithDispute: datastoreCollections.handoverWithDispute,
  getDisplayScore: datastoreCollections.getDisplayScore,
  isContestRubricSubmissionScoreArray:
    datastoreCollections.isContestRubricSubmissionScoreArray,
  withContestRubricSubmissionScore:
    datastoreCollections.withContestRubricSubmissionScore,
  isContestRubricSectionArray: datastoreCollections.isContestRubricSectionArray,
  acceptDocumentFileFormats: datastoreCollections.acceptDocumentFileFormats,
  withEntriesForContestViewEntryIds:
    datastoreCollections.withEntriesForContestViewEntryIds,
  withEntries: datastoreCollections.withEntries,
  pendingContest: datastoreCollections.pendingContest,
  closedContest: datastoreCollections.closedContest,
  richTextDescription: datastoreCollections.richTextDescription,
  soonExpiringContest: datastoreCollections.soonExpiringContest,
  guaranteedUpgrade: datastoreCollections.guaranteedUpgrade,
  ndaUpgrade: datastoreCollections.ndaUpgrade,
  withNdaUpgradeSigned: datastoreCollections.withNdaUpgradeSigned,
  sealedUpgrade: datastoreCollections.sealedUpgrade,
  contestIpContract: datastoreCollections.contestIpContract,
  signedBy: datastoreCollections.signedBy,
  isCountry: datastoreCollections.isCountry,
  countryRequiresWhatsappReducer:
    datastoreCollections.countryRequiresWhatsappReducer,
  countryRequiresWhatsappBackend:
    datastoreCollections.countryRequiresWhatsappBackend,
  usdCurrency: datastoreCollections.usdCurrency,
  tokenCurrency: datastoreCollections.tokenCurrency,
  currencyCodeFromId: datastoreCollections.currencyCodeFromId,
  linkCustomCta: datastoreCollections.linkCustomCta,
  modalCustomCta: datastoreCollections.modalCustomCta,
  getCustomFieldValues: datastoreCollections.getCustomFieldValues,
  getCustomFieldInfoConfigurationOptions:
    datastoreCollections.getCustomFieldInfoConfigurationOptions,
  firstName: datastoreCollections.firstName,
  lastName: datastoreCollections.lastName,
  level: datastoreCollections.level,
  legalEntityAlignment: datastoreCollections.legalEntityAlignment,
  practice: datastoreCollections.practice,
  offeringPortfolio: datastoreCollections.offeringPortfolio,
  independenceRuleset: datastoreCollections.independenceRuleset,
  phoneNumberWorkCell: datastoreCollections.phoneNumberWorkCell,
  phoneNumberSkype: datastoreCollections.phoneNumberSkype,
  memberFirmAlignment: datastoreCollections.memberFirmAlignment,
  countryAlignment: datastoreCollections.countryAlignment,
  emailAddress: datastoreCollections.emailAddress,
  certifications: datastoreCollections.certifications,
  getHpisProjectCustomFieldsAndValues:
    datastoreCollections.getHpisProjectCustomFieldsAndValues,
  getHpisEngineerNote: datastoreCollections.getHpisEngineerNote,
  getHpisTimeLog: datastoreCollections.getHpisTimeLog,
  getHpisPartOrder: datastoreCollections.getHpisPartOrder,
  createObjectCustomFields: datastoreCollections.createObjectCustomFields,
  getDeloitteProjectCustomFieldsAndValues:
    datastoreCollections.getDeloitteProjectCustomFieldsAndValues,
  getCustomFieldsAndValues: datastoreCollections.getCustomFieldsAndValues,
  customFieldRelationshipsBackend:
    datastoreCollections.customFieldRelationshipsBackend,
  customFieldRelationshipsReducer:
    datastoreCollections.customFieldRelationshipsReducer,
  wbsCodeToBusinessRelationship:
    datastoreCollections.wbsCodeToBusinessRelationship,
  wbsCodeToIndustryRelationship:
    datastoreCollections.wbsCodeToIndustryRelationship,
  wbsCodeToOfferingPortfolioRelationship:
    datastoreCollections.wbsCodeToOfferingPortfolioRelationship,
  wbsCodeToFSSValueRelationship:
    datastoreCollections.wbsCodeToFSSValueRelationship,
  oneOfValidationValues: datastoreCollections.oneOfValidationValues,
  deliveryContactsSensitiveDetailsBackend:
    datastoreCollections.deliveryContactsSensitiveDetailsBackend,
  userItem: datastoreCollections.userItem,
  userPermissionContext: datastoreCollections.userPermissionContext,
  readPermission: datastoreCollections.readPermission,
  deletePermission: datastoreCollections.deletePermission,
  projectViewPageFileContext: datastoreCollections.projectViewPageFileContext,
  encodedUrlForUserProfile: datastoreCollections.encodedUrlForUserProfile,
  facebookEnterprise: datastoreCollections.facebookEnterprise,
  deloitteEnterprise: datastoreCollections.deloitteEnterprise,
  hpEnterprise: datastoreCollections.hpEnterprise,
  insourceEnterprise: datastoreCollections.insourceEnterprise,
  freightlancerEnterprise: datastoreCollections.freightlancerEnterprise,
  nasaEnterprise: datastoreCollections.nasaEnterprise,
  incompleteEntryRequirements: datastoreCollections.incompleteEntryRequirements,
  incompleteAtoSerrEntryRequirements:
    datastoreCollections.incompleteAtoSerrEntryRequirements,
  vehicleTypeGroup: datastoreCollections.vehicleTypeGroup,
  loadingFacilitiesGroup: datastoreCollections.loadingFacilitiesGroup,
  bDoubleVehicleType: datastoreCollections.bDoubleVehicleType,
  bTripleVehicleType: datastoreCollections.bTripleVehicleType,
  curtainSiderVehicleType: datastoreCollections.curtainSiderVehicleType,
  uteVehicleType: datastoreCollections.uteVehicleType,
  vanVehicleType: datastoreCollections.vanVehicleType,
  tipperVehicleType: datastoreCollections.tipperVehicleType,
  vehicleCarrierVehicleType: datastoreCollections.vehicleCarrierVehicleType,
  floatVehicleType: datastoreCollections.floatVehicleType,
  forkliftType: datastoreCollections.forkliftType,
  palletJackType: datastoreCollections.palletJackType,
  craneType: datastoreCollections.craneType,
  telehandlerType: datastoreCollections.telehandlerType,
  uteType: datastoreCollections.uteType,
  academicWritingLevel1Exam: datastoreCollections.academicWritingLevel1Exam,
  adobePhotoShopCs5Level1Exam: datastoreCollections.adobePhotoShopCs5Level1Exam,
  androidLevel1Exam: datastoreCollections.androidLevel1Exam,
  dataEntryExam: datastoreCollections.dataEntryExam,
  javaScriptLevel1Exam: datastoreCollections.javaScriptLevel1Exam,
  phpLevel1Exam: datastoreCollections.phpLevel1Exam,
  usEnglishLevel1Exam: datastoreCollections.usEnglishLevel1Exam,
  withLocation: datastoreCollections.withLocation,
  feedForGroup: datastoreCollections.feedForGroup,
  feedForPost: datastoreCollections.feedForPost,
  feedForContestUpdates: datastoreCollections.feedForContestUpdates,
  groupFeedMeta: datastoreCollections.groupFeedMeta,
  feedPostToFeedItemTransformer:
    datastoreCollections.feedPostToFeedItemTransformer,
  groupMemberFeedPost: datastoreCollections.groupMemberFeedPost,
  textEntityUserPost: datastoreCollections.textEntityUserPost,
  textEntityUserComment: datastoreCollections.textEntityUserComment,
  mentionedUserTextEntityContent:
    datastoreCollections.mentionedUserTextEntityContent,
  mentionedProjectTextEntity: datastoreCollections.mentionedProjectTextEntity,
  feedPostFileAttachments: datastoreCollections.feedPostFileAttachments,
  isAttachment: datastoreCollections.isAttachment,
  rookieUserReputation: datastoreCollections.rookieUserReputation,
  grantEnterprise: datastoreCollections.grantEnterprise,
  grantPool: datastoreCollections.grantPool,
  hpDispatcherGrant: datastoreCollections.hpDispatcherGrant,
  analyticsViewerGrant: datastoreCollections.analyticsViewerGrant,
  manageEmailContentGrant: datastoreCollections.manageEmailContentGrant,
  groupsManagementGrant: datastoreCollections.groupsManagementGrant,
  groupsManagementBackendGrant:
    datastoreCollections.groupsManagementBackendGrant,
  loadshiftSupportGrant: datastoreCollections.loadshiftSupportGrant,
  bannersManagementGrant: datastoreCollections.bannersManagementGrant,
  groupActionsTransformers: datastoreCollections.groupActionsTransformers,
  groupAdmin: datastoreCollections.groupAdmin,
  groupModerator: datastoreCollections.groupModerator,
  groupMember: datastoreCollections.groupMember,
  groupGuest: datastoreCollections.groupGuest,
  groupMuted: datastoreCollections.groupMuted,
  groupMembers: datastoreCollections.groupMembers,
  groupAdmins: datastoreCollections.groupAdmins,
  groupModerators: datastoreCollections.groupModerators,
  groupGuests: datastoreCollections.groupGuests,
  groupMutedMembers: datastoreCollections.groupMutedMembers,
  adminPermissions: datastoreCollections.adminPermissions,
  moderatorPermissions: datastoreCollections.moderatorPermissions,
  memberPermissions: datastoreCollections.memberPermissions,
  guestPermissions: datastoreCollections.guestPermissions,
  mutedPermissions: datastoreCollections.mutedPermissions,
  deloitteInternalGroup: datastoreCollections.deloitteInternalGroup,
  inReviewGroup: datastoreCollections.inReviewGroup,
  getGroupOrderByFeedReadLatestTimeInMs:
    datastoreCollections.getGroupOrderByFeedReadLatestTimeInMs,
  contestContext: datastoreCollections.contestContext,
  getHirePageDetailsResultObject:
    datastoreCollections.getHirePageDetailsResultObject,
  phpHirePageDetailsResult: datastoreCollections.phpHirePageDetailsResult,
  incompleteHirePageDetailsResult:
    datastoreCollections.incompleteHirePageDetailsResult,
  genericHireStats: datastoreCollections.genericHireStats,
  currentMonthBestProjects: datastoreCollections.currentMonthBestProjects,
  previousMonthsBestProjects: datastoreCollections.previousMonthsBestProjects,
  bestProjects: datastoreCollections.bestProjects,
  createSimilarSkillsArray: datastoreCollections.createSimilarSkillsArray,
  autoBillingOnHourlyContract: datastoreCollections.autoBillingOnHourlyContract,
  autoBillingOffHourlyContract:
    datastoreCollections.autoBillingOffHourlyContract,
  activeHourlyContract: datastoreCollections.activeHourlyContract,
  inactiveHourlyContract: datastoreCollections.inactiveHourlyContract,
  hourlyContractFromBid: datastoreCollections.hourlyContractFromBid,
  australianHourlyProjectFees: datastoreCollections.australianHourlyProjectFees,
  invitationBlocksBackend: datastoreCollections.invitationBlocksBackend,
  invitationsBackend: datastoreCollections.invitationsBackend,
  registeredUserInvitation: datastoreCollections.registeredUserInvitation,
  unregisteredUserInvitation: datastoreCollections.unregisteredUserInvitation,
  openLinkInvitation: datastoreCollections.openLinkInvitation,
  restrictedLinkInvitation: datastoreCollections.restrictedLinkInvitation,
  getLanguages: datastoreCollections.getLanguages,
  buyerSignedContestHandover: datastoreCollections.buyerSignedContestHandover,
  sellerSignedContestHandover: datastoreCollections.sellerSignedContestHandover,
  buyerConfirmedContestHandover:
    datastoreCollections.buyerConfirmedContestHandover,
  sellerConfirmedContestHandover:
    datastoreCollections.sellerConfirmedContestHandover,
  forReviewContestHandover: datastoreCollections.forReviewContestHandover,
  withMobileNumber: datastoreCollections.withMobileNumber,
  withFirstModalWarning: datastoreCollections.withFirstModalWarning,
  withSecondModalWarning: datastoreCollections.withSecondModalWarning,
  withContactNumberRestrictionPenalty:
    datastoreCollections.withContactNumberRestrictionPenalty,
  withFullRestrictionPenalty: datastoreCollections.withFullRestrictionPenalty,
  bidOnPremiumProjectBenefit: datastoreCollections.bidOnPremiumProjectBenefit,
  clientEngagementBenefit: datastoreCollections.clientEngagementBenefit,
  skillsLimitBenefit: datastoreCollections.skillsLimitBenefit,
  aiFeaturesBenefit: datastoreCollections.aiFeaturesBenefit,
  multiProfilesBenefit: datastoreCollections.multiProfilesBenefit,
  employerFollowBenefit: datastoreCollections.employerFollowBenefit,
  enterpriseBenefit: datastoreCollections.enterpriseBenefit,
  portfolioCategoriesBenefit: datastoreCollections.portfolioCategoriesBenefit,
  bidCallingBenefit: datastoreCollections.bidCallingBenefit,
  subscriptionToSubscriptionHistoryTransformer:
    datastoreCollections.subscriptionToSubscriptionHistoryTransformer,
  awardProjectRichMessage: datastoreCollections.awardProjectRichMessage,
  contestAcceptOfferFreelancerRichMessage:
    datastoreCollections.contestAcceptOfferFreelancerRichMessage,
  contestAcceptOfferEmployerRichMessage:
    datastoreCollections.contestAcceptOfferEmployerRichMessage,
  offsitingMessageReminderFreelancerRichMessage:
    datastoreCollections.offsitingMessageReminderFreelancerRichMessage,
  createCanvasRichMessage: datastoreCollections.createCanvasRichMessage,
  createMilestoneReleaseRequestRichMessage:
    datastoreCollections.createMilestoneReleaseRequestRichMessage,
  createMilestoneRequestRichMessage:
    datastoreCollections.createMilestoneRequestRichMessage,
  createCustomerSatisfactionFeedbackRichMessage:
    datastoreCollections.createCustomerSatisfactionFeedbackRichMessage,
  createFreightlancerConciergeOutOfOfficeRichMessage:
    datastoreCollections.createFreightlancerConciergeOutOfOfficeRichMessage,
  createMilestoneReleaseReminderRichMessage:
    datastoreCollections.createMilestoneReleaseReminderRichMessage,
  createExternalCredentialRichMessage:
    datastoreCollections.createExternalCredentialRichMessage,
  milestoneDraftFromBid: datastoreCollections.milestoneDraftFromBid,
  milestoneRequestFromBid: datastoreCollections.milestoneRequestFromBid,
  pendingMilestoneRequest: datastoreCollections.pendingMilestoneRequest,
  createdMilestoneRequest: datastoreCollections.createdMilestoneRequest,
  partiallyPaidBidMilestone: datastoreCollections.partiallyPaidBidMilestone,
  fullyPaidBidMilestone: datastoreCollections.fullyPaidBidMilestone,
  initialPayment: datastoreCollections.initialPayment,
  milestoneFromBid: datastoreCollections.milestoneFromBid,
  milestoneFromQuotationItemRevision:
    datastoreCollections.milestoneFromQuotationItemRevision,
  frozenMilestone: datastoreCollections.frozenMilestone,
  canceledMilestone: datastoreCollections.canceledMilestone,
  clearedMilestone: datastoreCollections.clearedMilestone,
  disputedMilestone: datastoreCollections.disputedMilestone,
  pendingMilestone: datastoreCollections.pendingMilestone,
  requestedReleaseMilestone: datastoreCollections.requestedReleaseMilestone,
  pendingClearanceMilestone: datastoreCollections.pendingClearanceMilestone,
  pendingKycMilestone: datastoreCollections.pendingKycMilestone,
  unknownMilestone: datastoreCollections.unknownMilestone,
  isTestEntry: datastoreCollections.isTestEntry,
  isNewsfeedEntry: datastoreCollections.isNewsfeedEntry,
  isNotificationEntry: datastoreCollections.isNotificationEntry,
  newsfeedApiEntrySkipped: datastoreCollections.newsfeedApiEntrySkipped,
  userDisplayName: datastoreCollections.userDisplayName,
  deloitteOnBehalfProject: datastoreCollections.deloitteOnBehalfProject,
  freightlancerOnBehalfProject:
    datastoreCollections.freightlancerOnBehalfProject,
  onboardingEmailChangeBackend:
    datastoreCollections.onboardingEmailChangeBackend,
  openGraphDetailsBackend: datastoreCollections.openGraphDetailsBackend,
  openGraphDetailsReducer: datastoreCollections.openGraphDetailsReducer,
  nswWestRegion: datastoreCollections.nswWestRegion,
  nswSydneyRegion: datastoreCollections.nswSydneyRegion,
  nswSouthRegion: datastoreCollections.nswSouthRegion,
  saAdelaideRegion: datastoreCollections.saAdelaideRegion,
  saNorthRegion: datastoreCollections.saNorthRegion,
  qldBrisbaneRegion: datastoreCollections.qldBrisbaneRegion,
  vicMelbourneRegion: datastoreCollections.vicMelbourneRegion,
  vicEastRegion: datastoreCollections.vicEastRegion,
  tasmaniaRegion: datastoreCollections.tasmaniaRegion,
  wirePayoutAccountForm: datastoreCollections.wirePayoutAccountForm,
  payoutAccountsBackend: datastoreCollections.payoutAccountsBackend,
  wirePayoutAccountFieldData: datastoreCollections.wirePayoutAccountFieldData,
  wirePayoutMethod: datastoreCollections.wirePayoutMethod,
  freelancerPool: datastoreCollections.freelancerPool,
  deloittePool: datastoreCollections.deloittePool,
  facebookPool: datastoreCollections.facebookPool,
  flnltdPool: datastoreCollections.flnltdPool,
  talentNetworkPool: datastoreCollections.talentNetworkPool,
  deloitteFtnPool: datastoreCollections.deloitteFtnPool,
  anotherTalentNetworkPool: datastoreCollections.anotherTalentNetworkPool,
  hpPool: datastoreCollections.hpPool,
  insourceOnlyPool: datastoreCollections.insourceOnlyPool,
  freightlancerPool: datastoreCollections.freightlancerPool,
  heygenPool: datastoreCollections.heygenPool,
  kennardsPool: datastoreCollections.kennardsPool,
  customBudget: datastoreCollections.customBudget,
  listsFavoritesCollection: datastoreCollections.listsFavoritesCollection,
  hiresCollection: datastoreCollections.hiresCollection,
  clientsCollection: datastoreCollections.clientsCollection,
  recentlyViewedCollection: datastoreCollections.recentlyViewedCollection,
  groupFeedCollection: datastoreCollections.groupFeedCollection,
  preferredBillingAgreementsBackend:
    datastoreCollections.preferredBillingAgreementsBackend,
  activeCorporation: datastoreCollections.activeCorporation,
  withPhpExam: datastoreCollections.withPhpExam,
  withoutSkills: datastoreCollections.withoutSkills,
  defaultProfile: datastoreCollections.defaultProfile,
  webDesignProfile: datastoreCollections.webDesignProfile,
  graphicDesignProfile: datastoreCollections.graphicDesignProfile,
  webDevelopmentProfile: datastoreCollections.webDevelopmentProfile,
  mobileDevelopmentProfile: datastoreCollections.mobileDevelopmentProfile,
  dataEntryProfile: datastoreCollections.dataEntryProfile,
  zeroFees: datastoreCollections.zeroFees,
  australianSalesTax: datastoreCollections.australianSalesTax,
  awardAndChatCollaborator: datastoreCollections.awardAndChatCollaborator,
  projectFeedProjectEntriesFromSkills:
    datastoreCollections.projectFeedProjectEntriesFromSkills,
  bidToProjectViewBidTransformer:
    datastoreCollections.bidToProjectViewBidTransformer,
  orderBidsByBidScore: datastoreCollections.orderBidsByBidScore,
  createBidRankSortKey: datastoreCollections.createBidRankSortKey,
  createNumberBidRankSortKey: datastoreCollections.createNumberBidRankSortKey,
  createBooleanBidRankSortKey: datastoreCollections.createBooleanBidRankSortKey,
  invertNumberString: datastoreCollections.invertNumberString,
  invertBooleanString: datastoreCollections.invertBooleanString,
  projectViewProjectFromProject:
    datastoreCollections.projectViewProjectFromProject,
  websiteDesignProject: datastoreCollections.websiteDesignProject,
  cryptocurrencyProject: datastoreCollections.cryptocurrencyProject,
  localProject: datastoreCollections.localProject,
  projectFromSydney: datastoreCollections.projectFromSydney,
  projectFromMelbourne: datastoreCollections.projectFromMelbourne,
  projectFromVaticanCity: datastoreCollections.projectFromVaticanCity,
  linkedExternalProject: datastoreCollections.linkedExternalProject,
  linkedInternalProject: datastoreCollections.linkedInternalProject,
  bidStatsFromBids: datastoreCollections.bidStatsFromBids,
  rejectedProjectNote: datastoreCollections.rejectedProjectNote,
  freightLoad: datastoreCollections.freightLoad,
  updateProjectViewProjectBidStats:
    datastoreCollections.updateProjectViewProjectBidStats,
  deliveryProject: datastoreCollections.deliveryProject,
  asapDeliveryProject: datastoreCollections.asapDeliveryProject,
  estimateDeliveryProject: datastoreCollections.estimateDeliveryProject,
  withDeliveryItems: datastoreCollections.withDeliveryItems,
  projectToMelbourne: datastoreCollections.projectToMelbourne,
  deliveryItemSmall: datastoreCollections.deliveryItemSmall,
  deliveryItemLarge: datastoreCollections.deliveryItemLarge,
  deliveryItemOversized: datastoreCollections.deliveryItemOversized,
  deliveryItemWithSkillAnswer: datastoreCollections.deliveryItemWithSkillAnswer,
  fromInternalProject: datastoreCollections.fromInternalProject,
  withContactSignature: datastoreCollections.withContactSignature,
  getLocationPresets: datastoreCollections.getLocationPresets,
  getProjectViewUserLocations: datastoreCollections.getProjectViewUserLocations,
  fromSydney: datastoreCollections.fromSydney,
  fromMelbourne: datastoreCollections.fromMelbourne,
  fromKualaLumpur: datastoreCollections.fromKualaLumpur,
  fromDhaka: datastoreCollections.fromDhaka,
  fromKarachi: datastoreCollections.fromKarachi,
  fromMumbai: datastoreCollections.fromMumbai,
  fromDelhi: datastoreCollections.fromDelhi,
  fromAlberta: datastoreCollections.fromAlberta,
  fromSeattle: datastoreCollections.fromSeattle,
  fromVaticanCity: datastoreCollections.fromVaticanCity,
  fromRome: datastoreCollections.fromRome,
  activeUserSanction: datastoreCollections.activeUserSanction,
  userWithReviews: datastoreCollections.userWithReviews,
  rookieUser: datastoreCollections.rookieUser,
  nonRookieUser: datastoreCollections.nonRookieUser,
  rookieUsers: datastoreCollections.rookieUsers,
  withReputation: datastoreCollections.withReputation,
  fixedProject: datastoreCollections.fixedProject,
  fixedUsdProject: datastoreCollections.fixedUsdProject,
  fixedTokenProject: datastoreCollections.fixedTokenProject,
  hourlyUsdProject: datastoreCollections.hourlyUsdProject,
  pendingProject: datastoreCollections.pendingProject,
  rejectedProject: datastoreCollections.rejectedProject,
  cancelledProject: datastoreCollections.cancelledProject,
  closedProject: datastoreCollections.closedProject,
  expiredProject: datastoreCollections.expiredProject,
  awardedProject: datastoreCollections.awardedProject,
  incompleteProject: datastoreCollections.incompleteProject,
  completeProject: datastoreCollections.completeProject,
  premiumProject: datastoreCollections.premiumProject,
  premiumVerifiedProject: datastoreCollections.premiumVerifiedProject,
  largeBudgetNonPremiumProject:
    datastoreCollections.largeBudgetNonPremiumProject,
  deloitteProjectUpgrades: datastoreCollections.deloitteProjectUpgrades,
  enterpriseUpgrade: datastoreCollections.enterpriseUpgrade,
  facebookProject: datastoreCollections.facebookProject,
  deloitteInternalProject: datastoreCollections.deloitteInternalProject,
  deloitteLinkedExternalProject:
    datastoreCollections.deloitteLinkedExternalProject,
  hpProject: datastoreCollections.hpProject,
  ongoingProject: datastoreCollections.ongoingProject,
  projectHasOwnerId: datastoreCollections.projectHasOwnerId,
  withAdminAccessRole: datastoreCollections.withAdminAccessRole,
  withViewerAccessRole: datastoreCollections.withViewerAccessRole,
  withEditorAccessRole: datastoreCollections.withEditorAccessRole,
  formattedBillingFrequency: datastoreCollections.formattedBillingFrequency,
  billingInterval: datastoreCollections.billingInterval,
  attachedToQuotation: datastoreCollections.attachedToQuotation,
  validItem: datastoreCollections.validItem,
  validHourlyItem: datastoreCollections.validHourlyItem,
  validSubscriptionItem: datastoreCollections.validSubscriptionItem,
  invalidItem: datastoreCollections.invalidItem,
  deletedItem: datastoreCollections.deletedItem,
  completeItem: datastoreCollections.completeItem,
  draftQuotation: datastoreCollections.draftQuotation,
  currencyUSD: datastoreCollections.currencyUSD,
  withUserContext: datastoreCollections.withUserContext,
  approvedQuotation: datastoreCollections.approvedQuotation,
  invalidQuotation: datastoreCollections.invalidQuotation,
  rejectedQuotation: datastoreCollections.rejectedQuotation,
  cancelledQuotation: datastoreCollections.cancelledQuotation,
  expiredQuotation: datastoreCollections.expiredQuotation,
  publishedQuotation: datastoreCollections.publishedQuotation,
  externalQuotation: datastoreCollections.externalQuotation,
  setExpiryDate: datastoreCollections.setExpiryDate,
  templateQuotation: datastoreCollections.templateQuotation,
  serviceQuotation: datastoreCollections.serviceQuotation,
  withDuration: datastoreCollections.withDuration,
  fromServiceOffering: datastoreCollections.fromServiceOffering,
  reactionForPost: datastoreCollections.reactionForPost,
  recurringBillingInformationBackend:
    datastoreCollections.recurringBillingInformationBackend,
  normalizeContestReviewSeoUrl:
    datastoreCollections.normalizeContestReviewSeoUrl,
  forProject: datastoreCollections.forProject,
  forInvoice: datastoreCollections.forInvoice,
  forContest: datastoreCollections.forContest,
  toFreelancer: datastoreCollections.toFreelancer,
  toEmployer: datastoreCollections.toEmployer,
  getPriceTier: datastoreCollections.getPriceTier,
  mediumItem: datastoreCollections.mediumItem,
  largeItem: datastoreCollections.largeItem,
  locationPortArthurTAS: datastoreCollections.locationPortArthurTAS,
  locationWynyardNSW: datastoreCollections.locationWynyardNSW,
  locationDubboNSW: datastoreCollections.locationDubboNSW,
  locationBondiNSW: datastoreCollections.locationBondiNSW,
  locationRegencyParkSA: datastoreCollections.locationRegencyParkSA,
  locationBrisbaneQLD: datastoreCollections.locationBrisbaneQLD,
  locationMelbourneVIC: datastoreCollections.locationMelbourneVIC,
  fromContest: datastoreCollections.fromContest,
  searchSavedFiltersBackend: datastoreCollections.searchSavedFiltersBackend,
  isSearchSavedFiltersProject: datastoreCollections.isSearchSavedFiltersProject,
  isSearchSavedFiltersUser: datastoreCollections.isSearchSavedFiltersUser,
  isSearchSavedFiltersLoad: datastoreCollections.isSearchSavedFiltersLoad,
  isSearchSavedFiltersContest: datastoreCollections.isSearchSavedFiltersContest,
  isSearchSavedFiltersChallenge:
    datastoreCollections.isSearchSavedFiltersChallenge,
  encodeThreadId: datastoreCollections.encodeThreadId,
  decodeThreadId: datastoreCollections.decodeThreadId,
  rookieSearchUser: datastoreCollections.rookieSearchUser,
  nonRookieSearchUser: datastoreCollections.nonRookieSearchUser,
  serviceOfferingAttachmentsBackend:
    datastoreCollections.serviceOfferingAttachmentsBackend,
  serviceOfferingBuyerHistoriesBackend:
    datastoreCollections.serviceOfferingBuyerHistoriesBackend,
  serviceOfferingShopCategoriesBackend:
    datastoreCollections.serviceOfferingShopCategoriesBackend,
  serviceOfferingShopCategoryServicesBackend:
    datastoreCollections.serviceOfferingShopCategoryServicesBackend,
  serviceOfferingShopsBackend: datastoreCollections.serviceOfferingShopsBackend,
  serviceOfferingsBackend: datastoreCollections.serviceOfferingsBackend,
  activeServiceOffering: datastoreCollections.activeServiceOffering,
  hiddenServiceOffering: datastoreCollections.hiddenServiceOffering,
  draftServiceOffering: datastoreCollections.draftServiceOffering,
  serviceOfferingDiscountedPriceFixed:
    datastoreCollections.serviceOfferingDiscountedPriceFixed,
  serviceOfferingDiscountedPricePercentage:
    datastoreCollections.serviceOfferingDiscountedPricePercentage,
  serviceOfferingsWithOwnerDetailsBackend:
    datastoreCollections.serviceOfferingsWithOwnerDetailsBackend,
  setPreferredFreelancersOnlyBackend:
    datastoreCollections.setPreferredFreelancersOnlyBackend,
  setPreferredFreelancersOnlyReducer:
    datastoreCollections.setPreferredFreelancersOnlyReducer,
  getWebsiteBuildShowCase: datastoreCollections.getWebsiteBuildShowCase,
  snakeCase: datastoreCollections.snakeCase,
  phpSkill: datastoreCollections.phpSkill,
  perlSkill: datastoreCollections.perlSkill,
  javaSkill: datastoreCollections.javaSkill,
  javaScriptSkill: datastoreCollections.javaScriptSkill,
  adobeFlashSkill: datastoreCollections.adobeFlashSkill,
  pythonSkill: datastoreCollections.pythonSkill,
  websiteDesignSkill: datastoreCollections.websiteDesignSkill,
  graphicDesignSkill: datastoreCollections.graphicDesignSkill,
  copywritingSkill: datastoreCollections.copywritingSkill,
  translationSkill: datastoreCollections.translationSkill,
  photographySkill: datastoreCollections.photographySkill,
  linuxSkill: datastoreCollections.linuxSkill,
  logoDesignSkill: datastoreCollections.logoDesignSkill,
  dataProcessingSkill: datastoreCollections.dataProcessingSkill,
  dataEntrySkill: datastoreCollections.dataEntrySkill,
  accountingSkill: datastoreCollections.accountingSkill,
  photoshopSkill: datastoreCollections.photoshopSkill,
  androidSkill: datastoreCollections.androidSkill,
  mobileAppDevelopmentSkill: datastoreCollections.mobileAppDevelopmentSkill,
  articleWritingSkill: datastoreCollections.articleWritingSkill,
  deliverySkill: datastoreCollections.deliverySkill,
  freightSkill: datastoreCollections.freightSkill,
  palletsSkill: datastoreCollections.palletsSkill,
  skillQuestionDriveable: datastoreCollections.skillQuestionDriveable,
  skillAnswerDriveable: datastoreCollections.skillAnswerDriveable,
  skillAnswerNotDriveable: datastoreCollections.skillAnswerNotDriveable,
  skillQuestionEmpty: datastoreCollections.skillQuestionEmpty,
  skillQuestionRegistered: datastoreCollections.skillQuestionRegistered,
  skillAnswerRegistered: datastoreCollections.skillAnswerRegistered,
  skillAnswerNotRegistered: datastoreCollections.skillAnswerNotRegistered,
  skillQuestionPackageMethod: datastoreCollections.skillQuestionPackageMethod,
  skillQuestionRequiresProtection:
    datastoreCollections.skillQuestionRequiresProtection,
  skillQuestionHayOrGrassType: datastoreCollections.skillQuestionHayOrGrassType,
  carSkill: datastoreCollections.carSkill,
  haySkill: datastoreCollections.haySkill,
  machineryMobile: datastoreCollections.machineryMobile,
  machinerySkill: datastoreCollections.machinerySkill,
  generalFullLoadSkill: datastoreCollections.generalFullLoadSkill,
  otherSkill: datastoreCollections.otherSkill,
  cryptocurrencySkill: datastoreCollections.cryptocurrencySkill,
  heygenSkill: datastoreCollections.heygenSkill,
  phpSkillSubNavigationItem: datastoreCollections.phpSkillSubNavigationItem,
  linkedToProject: datastoreCollections.linkedToProject,
  subscriptionItemsBackend: datastoreCollections.subscriptionItemsBackend,
  getDefaultGroupPermissions: datastoreCollections.getDefaultGroupPermissions,
  withNotes: datastoreCollections.withNotes,
  unlistedProject: datastoreCollections.unlistedProject,
  relatedArticle: datastoreCollections.relatedArticle,
  withSupportBanner: datastoreCollections.withSupportBanner,
  swiftIdApplicantBackend: datastoreCollections.swiftIdApplicantBackend,
  swiftIdApplicationBackend: datastoreCollections.swiftIdApplicationBackend,
  swiftIdApplicationStatusBackend:
    datastoreCollections.swiftIdApplicationStatusBackend,
  swiftIdApplicationStatusReducer:
    datastoreCollections.swiftIdApplicationStatusReducer,
  swiftIdApplicationSubmitBackend:
    datastoreCollections.swiftIdApplicationSubmitBackend,
  swiftIdEnumBackend: datastoreCollections.swiftIdEnumBackend,
  swiftIdInvitationBackend: datastoreCollections.swiftIdInvitationBackend,
  swiftIdVerifySubmissionBackend:
    datastoreCollections.swiftIdVerifySubmissionBackend,
  getTaskSectionPresets: datastoreCollections.getTaskSectionPresets,
  withPermissions: datastoreCollections.withPermissions,
  withContext: datastoreCollections.withContext,
  withMessage: datastoreCollections.withMessage,
  withNoneContext: datastoreCollections.withNoneContext,
  withScreenshot: datastoreCollections.withScreenshot,
  timeTrackingSessionFromBid: datastoreCollections.timeTrackingSessionFromBid,
  usingAutomaticTimeTracking: datastoreCollections.usingAutomaticTimeTracking,
  contestSource: datastoreCollections.contestSource,
  fromSkill: datastoreCollections.fromSkill,
  getUsStates: datastoreCollections.getUsStates,
  userCustomEmailsBackend: datastoreCollections.userCustomEmailsBackend,
  active: datastoreCollections.active,
  inReview: datastoreCollections.inReview,
  userDocumentSubmissionFiles: datastoreCollections.userDocumentSubmissionFiles,
  infoDocumentSubmissionNote: datastoreCollections.infoDocumentSubmissionNote,
  warningDocumentSubmissionNote:
    datastoreCollections.warningDocumentSubmissionNote,
  errorDocumentSubmissionNote: datastoreCollections.errorDocumentSubmissionNote,
  userInfoFromUser: datastoreCollections.userInfoFromUser,
  userInfoWithSwitchUser: datastoreCollections.userInfoWithSwitchUser,
  doGooderBadge: datastoreCollections.doGooderBadge,
  foundationShareholderBadge: datastoreCollections.foundationShareholderBadge,
  forContestNps: datastoreCollections.forContestNps,
  forProjectNps: datastoreCollections.forProjectNps,
  toFreelancerNps: datastoreCollections.toFreelancerNps,
  fromEmployerNps: datastoreCollections.fromEmployerNps,
  withTargetId: datastoreCollections.withTargetId,
  activeNewsfeedGroup: datastoreCollections.activeNewsfeedGroup,
  muteNewsfeedGroup: datastoreCollections.muteNewsfeedGroup,
  aiAutoReplyDisabled: datastoreCollections.aiAutoReplyDisabled,
  aiAutoReplyEnabled: datastoreCollections.aiAutoReplyEnabled,
  chatboxAutoCloseEnabled: datastoreCollections.chatboxAutoCloseEnabled,
  chatboxAutoCloseDisabled: datastoreCollections.chatboxAutoCloseDisabled,
  aiAutoReplyUnset: datastoreCollections.aiAutoReplyUnset,
  getUserSettingId: datastoreCollections.getUserSettingId,
  userSkillsFromSkills: datastoreCollections.userSkillsFromSkills,
  userFromUsersSelf: datastoreCollections.userFromUsersSelf,
  employerUser: datastoreCollections.employerUser,
  freelancerUser: datastoreCollections.freelancerUser,
  pmiUser: datastoreCollections.pmiUser,
  facebookUser: datastoreCollections.facebookUser,
  hpUser: datastoreCollections.hpUser,
  deloitteUser: datastoreCollections.deloitteUser,
  insourceUser: datastoreCollections.insourceUser,
  loadshiftUser: datastoreCollections.loadshiftUser,
  deloitteUserWithCustomFields:
    datastoreCollections.deloitteUserWithCustomFields,
  nasaUser: datastoreCollections.nasaUser,
  facebookCertifiedUser: datastoreCollections.facebookCertifiedUser,
  deloitteFTNUser: datastoreCollections.deloitteFTNUser,
  unverifiedUser: datastoreCollections.unverifiedUser,
  verifiedUser: datastoreCollections.verifiedUser,
  emailUnverifiedUser: datastoreCollections.emailUnverifiedUser,
  phoneUnverifiedUser: datastoreCollections.phoneUnverifiedUser,
  paymentUnverifiedUser: datastoreCollections.paymentUnverifiedUser,
  freelancerUnverifiedUser: datastoreCollections.freelancerUnverifiedUser,
  supportStaff: datastoreCollections.supportStaff,
  identityVerifiedUser: datastoreCollections.identityVerifiedUser,
  californianUser: datastoreCollections.californianUser,
  supportUser: datastoreCollections.supportUser,
  recruiterUser: datastoreCollections.recruiterUser,
  staffUser: datastoreCollections.staffUser,
  mfaEmailAndPhoneDetails: datastoreCollections.mfaEmailAndPhoneDetails,
  mfaEmailOnly: datastoreCollections.mfaEmailOnly,
  biddingCompleteUserProfile: datastoreCollections.biddingCompleteUserProfile,
  escrowProfileCompleteUserSelf:
    datastoreCollections.escrowProfileCompleteUserSelf,
  australianUser: datastoreCollections.australianUser,
  usersTeamProfileBackend: datastoreCollections.usersTeamProfileBackend,
  usersTeamProfileReducer: datastoreCollections.usersTeamProfileReducer,
  verificationCorporateKycBackend:
    datastoreCollections.verificationCorporateKycBackend,
  documentType: datastoreCollections.documentType,
  documentTypeFiles: datastoreCollections.documentTypeFiles,
  driversLicense: datastoreCollections.driversLicense,
  currencyForPublicLiability: datastoreCollections.currencyForPublicLiability,
  loadshiftCarrierVerification:
    datastoreCollections.loadshiftCarrierVerification,
  insuranceVerification: datastoreCollections.insuranceVerification,
  freelancerVideoVerification: datastoreCollections.freelancerVideoVerification,
  approvedKycRequest: datastoreCollections.approvedKycRequest,
  rejectedKycRequest: datastoreCollections.rejectedKycRequest,
  incompleteKycRequest: datastoreCollections.incompleteKycRequest,
  unsubmittedKycRequestDetails:
    datastoreCollections.unsubmittedKycRequestDetails,
  pendingKycRequestWithAddressDocument:
    datastoreCollections.pendingKycRequestWithAddressDocument,
  idDetailsOnly: datastoreCollections.idDetailsOnly,
  specificDetails: datastoreCollections.specificDetails,
  withdrawalVideoVerificationRequest:
    datastoreCollections.withdrawalVideoVerificationRequest,
  getAuth: documentCreators.getAuth,
  setAuth: documentCreators.setAuth,
  setDatastoreController: documentCreators.setDatastoreController,
  createDoc: documentCreators.createDoc,
  createRawDocument: documentCreators.createRawDocument,
  resetDatastoreState: documentCreators.resetDatastoreState,
  printRawDatastoreState: documentCreators.printRawDatastoreState,
  printState: documentCreators.printState,
  addMutationPropagator: documentCreators.addMutationPropagator,
  addPushTransformer: documentCreators.addPushTransformer,
  addUpdateTransformer: documentCreators.addUpdateTransformer,
  addSearchTransformer: documentCreators.addSearchTransformer,
  makeRequestFail: documentCreators.makeRequestFail,
  clearRequestFail: documentCreators.clearRequestFail,
  makeCollectionFailFetch: documentCreators.makeCollectionFailFetch,
  clearCollectionFailFetch: documentCreators.clearCollectionFailFetch,
  makeCollectionFailPush: documentCreators.makeCollectionFailPush,
  clearCollectionFailPush: documentCreators.clearCollectionFailPush,
  makeCollectionFailSet: documentCreators.makeCollectionFailSet,
  clearCollectionFailSet: documentCreators.clearCollectionFailSet,
  makeCollectionFailUpdate: documentCreators.makeCollectionFailUpdate,
  clearCollectionFailUpdate: documentCreators.clearCollectionFailUpdate,
  makeCollectionFailDelete: documentCreators.makeCollectionFailDelete,
  clearCollectionFailDelete: documentCreators.clearCollectionFailDelete,
  makeCollectionFailWhenEmpty: documentCreators.makeCollectionFailWhenEmpty,
  clearCollectionFailWhenEmpty: documentCreators.clearCollectionFailWhenEmpty,
  makeCollectionDelayed: documentCreators.makeCollectionDelayed,
  clearCollectionDelayed: documentCreators.clearCollectionDelayed,
  makeCollectionPending: documentCreators.makeCollectionPending,
  clearCollectionPending: documentCreators.clearCollectionPending,
  signup: documentCreators.signup,
  signupAndLogin: documentCreators.signupAndLogin,
  createAbnDetails: documentCreators.createAbnDetails,
  createAdminProject: documentCreators.createAdminProject,
  createAdminProjectDescriptionUpdate:
    documentCreators.createAdminProjectDescriptionUpdate,
  createAppInstallTrackingRecord:
    documentCreators.createAppInstallTrackingRecord,
  createBidRestriction: documentCreators.createBidRestriction,
  createBidSummary: documentCreators.createBidSummary,
  createBidUpgradeFee: documentCreators.createBidUpgradeFee,
  createBillingAgreement: documentCreators.createBillingAgreement,
  createCanViewEmployerProfile: documentCreators.createCanViewEmployerProfile,
  createCartItem: documentCreators.createCartItem,
  createCart: documentCreators.createCart,
  createCartApproval: documentCreators.createCartApproval,
  createCategoryPageContent: documentCreators.createCategoryPageContent,
  createCertification: documentCreators.createCertification,
  createContentCustomization: documentCreators.createContentCustomization,
  createCustomBanner: documentCreators.createCustomBanner,
  createChallenge: documentCreators.createChallenge,
  createAdminChallenge: documentCreators.createAdminChallenge,
  createContest: documentCreators.createContest,
  createContestEngagement: documentCreators.createContestEngagement,
  createContestEntry: documentCreators.createContestEntry,
  createContestEntryOffer: documentCreators.createContestEntryOffer,
  createContestHandover: documentCreators.createContestHandover,
  createContestHandoverContractDetails:
    documentCreators.createContestHandoverContractDetails,
  createContestHandoverFile: documentCreators.createContestHandoverFile,
  createContestViewContest: documentCreators.createContestViewContest,
  createContestFile: documentCreators.createContestFile,
  createContestCollaborator: documentCreators.createContestCollaborator,
  createContestPrizeDetail: documentCreators.createContestPrizeDetail,
  createContestUserHasGivenFeedback:
    documentCreators.createContestUserHasGivenFeedback,
  createContract: documentCreators.createContract,
  createContractDownloadUrl: documentCreators.createContractDownloadUrl,
  createDomain: documentCreators.createDomain,
  createEducation: documentCreators.createEducation,
  createEncodedUrl: documentCreators.createEncodedUrl,
  createEntryRestriction: documentCreators.createEntryRestriction,
  createExperience: documentCreators.createExperience,
  createExperiences: documentCreators.createExperiences,
  createFreelancerReputation: documentCreators.createFreelancerReputation,
  createFreelancerReputationsRehireRate:
    documentCreators.createFreelancerReputationsRehireRate,
  createHourlyContract: documentCreators.createHourlyContract,
  createHourlyProjectMilestoneFee:
    documentCreators.createHourlyProjectMilestoneFee,
  createInvitation: documentCreators.createInvitation,
  createLanguage: documentCreators.createLanguage,
  createLlmBidSearchSuggestions: documentCreators.createLlmBidSearchSuggestions,
  createLoadshiftSiteStats: documentCreators.createLoadshiftSiteStats,
  createMembershipBenefit: documentCreators.createMembershipBenefit,
  createMessage: documentCreators.createMessage,
  createMilestone: documentCreators.createMilestone,
  createMilestones: documentCreators.createMilestones,
  createMilestoneDraft: documentCreators.createMilestoneDraft,
  createNearbyProject: documentCreators.createNearbyProject,
  createNewsfeedProjectAccepted: documentCreators.createNewsfeedProjectAccepted,
  createNewsfeedActivateFreelancer:
    documentCreators.createNewsfeedActivateFreelancer,
  createNewsfeedProjectAwarded: documentCreators.createNewsfeedProjectAwarded,
  createNewsfeedDenied: documentCreators.createNewsfeedDenied,
  createNewsfeedInviteUserBid: documentCreators.createNewsfeedInviteUserBid,
  createNewsfeedProjectBidOn: documentCreators.createNewsfeedProjectBidOn,
  createNewsfeedProjectReviewPostedNew:
    documentCreators.createNewsfeedProjectReviewPostedNew,
  createNewsfeedProjectEditRequest:
    documentCreators.createNewsfeedProjectEditRequest,
  createNewsfeedProjectReviewActivate:
    documentCreators.createNewsfeedProjectReviewActivate,
  createNewsfeedProjectSharedWithYou:
    documentCreators.createNewsfeedProjectSharedWithYou,
  createNewsfeedContestSharedWithYou:
    documentCreators.createNewsfeedContestSharedWithYou,
  createNewsfeedRejected: documentCreators.createNewsfeedRejected,
  createNewsfeedBookmarkedProjectAwarded:
    documentCreators.createNewsfeedBookmarkedProjectAwarded,
  createNewsfeedContestPcb: documentCreators.createNewsfeedContestPcb,
  createNewsfeedDraftContest: documentCreators.createNewsfeedDraftContest,
  createNewsfeedCreateAwardedBidEditRequest:
    documentCreators.createNewsfeedCreateAwardedBidEditRequest,
  createNewsfeedCreateMilestone: documentCreators.createNewsfeedCreateMilestone,
  createNewsfeedHireMe: documentCreators.createNewsfeedHireMe,
  createNewsfeedHireMeExpired: documentCreators.createNewsfeedHireMeExpired,
  createNewsfeedInternalLinkedProjectAwardReminder:
    documentCreators.createNewsfeedInternalLinkedProjectAwardReminder,
  createNewsfeedRequestToRelease:
    documentCreators.createNewsfeedRequestToRelease,
  createNewsfeedSendQuote: documentCreators.createNewsfeedSendQuote,
  createNewsfeedReleaseMilestone:
    documentCreators.createNewsfeedReleaseMilestone,
  createNewsfeedUpdateMilestone: documentCreators.createNewsfeedUpdateMilestone,
  createNewsfeedRequestMilestone:
    documentCreators.createNewsfeedRequestMilestone,
  createNewsfeedIndianMandateMembershipRecurringReminder:
    documentCreators.createNewsfeedIndianMandateMembershipRecurringReminder,
  createNewsfeedIndianMandateMembershipVerificationReminder:
    documentCreators.createNewsfeedIndianMandateMembershipVerificationReminder,
  createNewsfeedEscalateDispute: documentCreators.createNewsfeedEscalateDispute,
  createNewsfeedCorporateTeamBidPlaced:
    documentCreators.createNewsfeedCorporateTeamBidPlaced,
  createNewsfeedCustomAdminNotification:
    documentCreators.createNewsfeedCustomAdminNotification,
  createNewsfeedAwardProjectCorporateTeam:
    documentCreators.createNewsfeedAwardProjectCorporateTeam,
  createShowcaseClientNotification:
    documentCreators.createShowcaseClientNotification,
  createNewsfeedShowcaseSourceApproval:
    documentCreators.createNewsfeedShowcaseSourceApproval,
  createNewsfeedClientViewedBid: documentCreators.createNewsfeedClientViewedBid,
  createNewsfeedSuggestionForFreelancerAfterReceiveReview:
    documentCreators.createNewsfeedSuggestionForFreelancerAfterReceiveReview,
  createNewsfeedTaskGroupNewUser:
    documentCreators.createNewsfeedTaskGroupNewUser,
  createNewsfeedWelcome: documentCreators.createNewsfeedWelcome,
  createExternalReferenceReminder:
    documentCreators.createExternalReferenceReminder,
  createNotificationGroupNotification:
    documentCreators.createNotificationGroupNotification,
  createNotificationGroupReactNotification:
    documentCreators.createNotificationGroupReactNotification,
  createNotificationGroupReplyNotification:
    documentCreators.createNotificationGroupReplyNotification,
  createNotificationProjectCommentCreate:
    documentCreators.createNotificationProjectCommentCreate,
  createNotificationTaskCommentCreate:
    documentCreators.createNotificationTaskCommentCreate,
  createNotificationProjectSharedWithYou:
    documentCreators.createNotificationProjectSharedWithYou,
  createNotificationContestSharedWithYou:
    documentCreators.createNotificationContestSharedWithYou,
  createNotificationTaskCreateEdit:
    documentCreators.createNotificationTaskCreateEdit,
  createNotificationTaskGroupNewUser:
    documentCreators.createNotificationTaskGroupNewUser,
  createNotificationRequestMilestone:
    documentCreators.createNotificationRequestMilestone,
  createNotificationRequestToRelease:
    documentCreators.createNotificationRequestToRelease,
  createNotificationUpgradeToNonFreeMembership:
    documentCreators.createNotificationUpgradeToNonFreeMembership,
  createNotificationUploadFile: documentCreators.createNotificationUploadFile,
  createNotificationProjectCompleted:
    documentCreators.createNotificationProjectCompleted,
  createNotificationRequestCancelMilestone:
    documentCreators.createNotificationRequestCancelMilestone,
  createNotificationEarningTaxCollected:
    documentCreators.createNotificationEarningTaxCollected,
  createPortfolio: documentCreators.createPortfolio,
  createCategory: documentCreators.createCategory,
  createContestRubric: documentCreators.createContestRubric,
  createContestRubricSubmission: documentCreators.createContestRubricSubmission,
  createContestEntryJudgeAssignment:
    documentCreators.createContestEntryJudgeAssignment,
  createProfileViewUser: documentCreators.createProfileViewUser,
  createProjectBidInfo: documentCreators.createProjectBidInfo,
  createProjectBidStats: documentCreators.createProjectBidStats,
  createProjectBookmark: documentCreators.createProjectBookmark,
  createProjectBookmarks: documentCreators.createProjectBookmarks,
  createProject: documentCreators.createProject,
  createProjectTitleEditRequest: documentCreators.createProjectTitleEditRequest,
  createThreadProject: documentCreators.createThreadProject,
  createProjectViewProject: documentCreators.createProjectViewProject,
  createProjectDeliveryContactSensitiveDetails:
    documentCreators.createProjectDeliveryContactSensitiveDetails,
  createUserContactPhone: documentCreators.createUserContactPhone,
  createMilestoneRequest: documentCreators.createMilestoneRequest,
  createMilestoneRequests: documentCreators.createMilestoneRequests,
  createProjectViewUser: documentCreators.createProjectViewUser,
  createPublication: documentCreators.createPublication,
  createReview: documentCreators.createReview,
  createReviews: documentCreators.createReviews,
  createReviewSkill: documentCreators.createReviewSkill,
  createReferralInvitationCheck: documentCreators.createReferralInvitationCheck,
  createReferralEligibility: documentCreators.createReferralEligibility,
  createReferralTokenObject: documentCreators.createReferralTokenObject,
  createSimilarFreelancers: documentCreators.createSimilarFreelancers,
  createSimilarShowcases: documentCreators.createSimilarShowcases,
  createSiteStat: documentCreators.createSiteStat,
  createLoadPriceEstimate: documentCreators.createLoadPriceEstimate,
  createSuggestedSkills: documentCreators.createSuggestedSkills,
  createSearchActiveContest: documentCreators.createSearchActiveContest,
  createSearchActiveContests: documentCreators.createSearchActiveContests,
  createSearchActiveProject: documentCreators.createSearchActiveProject,
  createSearchActiveProjects: documentCreators.createSearchActiveProjects,
  createSearchUser: documentCreators.createSearchUser,
  createUserConnectionsSearch: documentCreators.createUserConnectionsSearch,
  createSearchSavedFilters: documentCreators.createSearchSavedFilters,
  createSearchProjectsSelf: documentCreators.createSearchProjectsSelf,
  createSuperuserProjectViewAllProject:
    documentCreators.createSuperuserProjectViewAllProject,
  createSuperuserProjectViewProject:
    documentCreators.createSuperuserProjectViewProject,
  createSuperuserProjectViewUser:
    documentCreators.createSuperuserProjectViewUser,
  createSuperuserBids: documentCreators.createSuperuserBids,
  createTaskGroup: documentCreators.createTaskGroup,
  createTaskGroupSection: documentCreators.createTaskGroupSection,
  createTaskGroupSections: documentCreators.createTaskGroupSections,
  createTask: documentCreators.createTask,
  createTaskGroupMembers: documentCreators.createTaskGroupMembers,
  createTax: documentCreators.createTax,
  createTeam: documentCreators.createTeam,
  createTeamMember: documentCreators.createTeamMember,
  createTeamMembers: documentCreators.createTeamMembers,
  createTimeTrackingPunches: documentCreators.createTimeTrackingPunches,
  createTimeTrackingPunch: documentCreators.createTimeTrackingPunch,
  createTimeTrackingSession: documentCreators.createTimeTrackingSession,
  createTimeTrackingDailyAggregate:
    documentCreators.createTimeTrackingDailyAggregate,
  createThread: documentCreators.createThread,
  createAdminThread: documentCreators.createAdminThread,
  createVideochat: documentCreators.createVideochat,
  createUserAvailability: documentCreators.createUserAvailability,
  createUserAvailabilityAgent: documentCreators.createUserAvailabilityAgent,
  createUserBidLimit: documentCreators.createUserBidLimit,
  createUserEmailRequest: documentCreators.createUserEmailRequest,
  createUserFollow: documentCreators.createUserFollow,
  createUserGiveGetDetail: documentCreators.createUserGiveGetDetail,
  createUserHasDuplicateIp: documentCreators.createUserHasDuplicateIp,
  createUserHasGivenFeedback: documentCreators.createUserHasGivenFeedback,
  createUserInfo: documentCreators.createUserInfo,
  createUserInsignias: documentCreators.createUserInsignias,
  createUserLocation: documentCreators.createUserLocation,
  createUserRequiresGdpr: documentCreators.createUserRequiresGdpr,
  createUserRequiresPaymentVerification:
    documentCreators.createUserRequiresPaymentVerification,
  createUserRequiresPhoneVerification:
    documentCreators.createUserRequiresPhoneVerification,
  createProjectSpamControls: documentCreators.createProjectSpamControls,
  createUser: documentCreators.createUser,
  createUserColleagues: documentCreators.createUserColleagues,
  createUsersProfile: documentCreators.createUsersProfile,
  createUsersSelf: documentCreators.createUsersSelf,
  createUsersMfaObject: documentCreators.createUsersMfaObject,
  createUserPaymentControl: documentCreators.createUserPaymentControl,
  createLoginDevicesObject: documentCreators.createLoginDevicesObject,
  createUserTaxInfoObject: documentCreators.createUserTaxInfoObject,
  createUserTaxOptOutReasonObject:
    documentCreators.createUserTaxOptOutReasonObject,
  createSecurityPhoneRequestObject:
    documentCreators.createSecurityPhoneRequestObject,
  createInvoice: documentCreators.createInvoice,
  createIsFreeBids: documentCreators.createIsFreeBids,
  createUserBidOnRussianProject: documentCreators.createUserBidOnRussianProject,
  createRecentSavedSearchAlert: documentCreators.createRecentSavedSearchAlert,
  createAdminUserVerificationProcess:
    documentCreators.createAdminUserVerificationProcess,
  createSessionResolveReason: documentCreators.createSessionResolveReason,
  createDriveFile: documentCreators.createDriveFile,
  createDriveFilePermission: documentCreators.createDriveFilePermission,
  createSuperuserMilestone: documentCreators.createSuperuserMilestone,
  createSuperuserGroupPermissions:
    documentCreators.createSuperuserGroupPermissions,
  createSuperuserGroupMembers: documentCreators.createSuperuserGroupMembers,
  createCustomFieldRelationship: documentCreators.createCustomFieldRelationship,
  createCustomFieldValidation: documentCreators.createCustomFieldValidation,
  createArticle: documentCreators.createArticle,
  createUserNps: documentCreators.createUserNps,
  createAccountProgress: documentCreators.createAccountProgress,
  createDashboardPoll: documentCreators.createDashboardPoll,
  createVideoVerificationRequest:
    documentCreators.createVideoVerificationRequest,
  createMarketingMobileNumber: documentCreators.createMarketingMobileNumber,
  createTimeline: documentCreators.createTimeline,
  createReferralInvitation: documentCreators.createReferralInvitation,
  createUserPhoneVerificationBackoff:
    documentCreators.createUserPhoneVerificationBackoff,
  createCategoryPageViewUser: documentCreators.createCategoryPageViewUser,
  createDiscoverCollectionItemSaveCount:
    documentCreators.createDiscoverCollectionItemSaveCount,
  createDiscoverCollection: documentCreators.createDiscoverCollection,
  createSupportFeedbackIsAllowed:
    documentCreators.createSupportFeedbackIsAllowed,
  createSlaTask: documentCreators.createSlaTask,
  createUserCartRequiresEmailVerification:
    documentCreators.createUserCartRequiresEmailVerification,
  createProjectMatchInsight: documentCreators.createProjectMatchInsight,
  createProjectContestClassification:
    documentCreators.createProjectContestClassification,
  createExternalContactStatus: documentCreators.createExternalContactStatus,
  createTrackingConsentMode: documentCreators.createTrackingConsentMode,
  createUserConsent: documentCreators.createUserConsent,
  createAdminExternalCredentialAllocation:
    documentCreators.createAdminExternalCredentialAllocation,
  createAdminExternalCredentialAllocationLog:
    documentCreators.createAdminExternalCredentialAllocationLog,
  createAdminExternalCredentialProvider:
    documentCreators.createAdminExternalCredentialProvider,
  createJobClassifier: documentCreators.createJobClassifier,
  createBanners: documentCreators.createBanners,
  createBid: documentCreators.createBid,
  createBids: documentCreators.createBids,
  createBidVectorSearchAnnotation:
    documentCreators.createBidVectorSearchAnnotation,
  createBidVectorSearchAnnotations:
    documentCreators.createBidVectorSearchAnnotations,
  createProjectAiSummary: documentCreators.createProjectAiSummary,
  createProjectAiSummaries: documentCreators.createProjectAiSummaries,
  createProjectCollaboration: documentCreators.createProjectCollaboration,
  createUserCollaboration: documentCreators.createUserCollaboration,
  createProjectCollaborations: documentCreators.createProjectCollaborations,
  createContestEntries: documentCreators.createContestEntries,
  createContestViewEntryIds: documentCreators.createContestViewEntryIds,
  createContestFees: documentCreators.createContestFees,
  createContestFiles: documentCreators.createContestFiles,
  createContestInterestedUser: documentCreators.createContestInterestedUser,
  createContestsInterestedIn: documentCreators.createContestsInterestedIn,
  createContestQuickviewEntries: documentCreators.createContestQuickviewEntries,
  createContestViewEntries: documentCreators.createContestViewEntries,
  createSearchContestEntrants: documentCreators.createSearchContestEntrants,
  createSearchContestEntries: documentCreators.createSearchContestEntries,
  createContestBudgetRanges: documentCreators.createContestBudgetRanges,
  createCountries: documentCreators.createCountries,
  createCurrencies: documentCreators.createCurrencies,
  createDetectedCurrencies: documentCreators.createDetectedCurrencies,
  createVehicleTypes: documentCreators.createVehicleTypes,
  createCurrencyIncludingExternal:
    documentCreators.createCurrencyIncludingExternal,
  createDashboardWidgets: documentCreators.createDashboardWidgets,
  createExams: documentCreators.createExams,
  createDepositPageVars: documentCreators.createDepositPageVars,
  createUserDepositMethods: documentCreators.createUserDepositMethods,
  createUserPayoutAccounts: documentCreators.createUserPayoutAccounts,
  createUserPayoutAccountForms: documentCreators.createUserPayoutAccountForms,
  createUserPayoutContext: documentCreators.createUserPayoutContext,
  createUserPayoutMethods: documentCreators.createUserPayoutMethods,
  createExchangeRates: documentCreators.createExchangeRates,
  createNativeExchangeRates: documentCreators.createNativeExchangeRates,
  createFreelancerReputations: documentCreators.createFreelancerReputations,
  createFreelancerReputationsRehireRates:
    documentCreators.createFreelancerReputationsRehireRates,
  createEmployerReputationsRehireRates:
    documentCreators.createEmployerReputationsRehireRates,
  createManageViewOpenBids: documentCreators.createManageViewOpenBids,
  createManageViewOngoingBids: documentCreators.createManageViewOngoingBids,
  createManageViewOngoingProjects:
    documentCreators.createManageViewOngoingProjects,
  createMessages: documentCreators.createMessages,
  createNotificationsPreferences:
    documentCreators.createNotificationsPreferences,
  createOnlineOffline: documentCreators.createOnlineOffline,
  createPools: documentCreators.createPools,
  createAdminPools: documentCreators.createAdminPools,
  createAgent: documentCreators.createAgent,
  createAgents: documentCreators.createAgents,
  createAgentSession: documentCreators.createAgentSession,
  createAgentSessions: documentCreators.createAgentSessions,
  createAiEscalation: documentCreators.createAiEscalation,
  createSupportTag: documentCreators.createSupportTag,
  createAiPrompt: documentCreators.createAiPrompt,
  createAiPromptBuilder: documentCreators.createAiPromptBuilder,
  createSalesTax: documentCreators.createSalesTax,
  createPortfolios: documentCreators.createPortfolios,
  createPredictedSkill: documentCreators.createPredictedSkill,
  createProjectSkillsPrediction: documentCreators.createProjectSkillsPrediction,
  createPreferredBillingAgreement:
    documentCreators.createPreferredBillingAgreement,
  createProfileViewUsers: documentCreators.createProfileViewUsers,
  createProjectBudgetOptions: documentCreators.createProjectBudgetOptions,
  createProjectFeed: documentCreators.createProjectFeed,
  createProjectGroup: documentCreators.createProjectGroup,
  createProjectGroups: documentCreators.createProjectGroups,
  createProjectQualityDetails: documentCreators.createProjectQualityDetails,
  createProjectUpgradeFees: documentCreators.createProjectUpgradeFees,
  createProjectViewBids: documentCreators.createProjectViewBids,
  createProjectViewBidsSearchMetadata:
    documentCreators.createProjectViewBidsSearchMetadata,
  createBidScore: documentCreators.createBidScore,
  createBidBuyerProjectFee: documentCreators.createBidBuyerProjectFee,
  createProjectViewUsers: documentCreators.createProjectViewUsers,
  createSearchUsers: documentCreators.createSearchUsers,
  createShowcaseSources: documentCreators.createShowcaseSources,
  createSkills: documentCreators.createSkills,
  createTopSkills: documentCreators.createTopSkills,
  createUserSkills: documentCreators.createUserSkills,
  createUniversities: documentCreators.createUniversities,
  createUserBalances: documentCreators.createUserBalances,
  createUserCalifornianStatuses: documentCreators.createUserCalifornianStatuses,
  createUserRestrictions: documentCreators.createUserRestrictions,
  createUserQualityDetails: documentCreators.createUserQualityDetails,
  createUserRecentProjectsAndContests:
    documentCreators.createUserRecentProjectsAndContests,
  createUsers: documentCreators.createUsers,
  createOnBehalfProject: documentCreators.createOnBehalfProject,
  createCustomFieldInfoConfigurations:
    documentCreators.createCustomFieldInfoConfigurations,
  createGroup: documentCreators.createGroup,
  createGroups: documentCreators.createGroups,
  createSuperuserGroup: documentCreators.createSuperuserGroup,
  createSuperuserGroups: documentCreators.createSuperuserGroups,
  createGroupsSelf: documentCreators.createGroupsSelf,
  createGroupMembers: documentCreators.createGroupMembers,
  createGroupActions: documentCreators.createGroupActions,
  createGroupPermissions: documentCreators.createGroupPermissions,
  createPostFiles: documentCreators.createPostFiles,
  createGroupAttachments: documentCreators.createGroupAttachments,
  createFeedPost: documentCreators.createFeedPost,
  createFeedMeta: documentCreators.createFeedMeta,
  createFeedItem: documentCreators.createFeedItem,
  createGroupFeed: documentCreators.createGroupFeed,
  createCommentFeed: documentCreators.createCommentFeed,
  createContentCustomizations: documentCreators.createContentCustomizations,
  createGrant: documentCreators.createGrant,
  createGrants: documentCreators.createGrants,
  createParentContestComment: documentCreators.createParentContestComment,
  createReplyContestComment: documentCreators.createReplyContestComment,
  createEnterprise: documentCreators.createEnterprise,
  createEnterprises: documentCreators.createEnterprises,
  createAdminEnterprises: documentCreators.createAdminEnterprises,
  createAdminUserEnterprises: documentCreators.createAdminUserEnterprises,
  createReactionsTypeCount: documentCreators.createReactionsTypeCount,
  createReactionTypeCount: documentCreators.createReactionTypeCount,
  createComments: documentCreators.createComments,
  createCommentWithMutationPropagation:
    documentCreators.createCommentWithMutationPropagation,
  createComment: documentCreators.createComment,
  createUserContestCollaborationWhitelist:
    documentCreators.createUserContestCollaborationWhitelist,
  createPaymentShareWhitelistItem:
    documentCreators.createPaymentShareWhitelistItem,
  createPaymentShareTeams: documentCreators.createPaymentShareTeams,
  createPaymentShareMembers: documentCreators.createPaymentShareMembers,
  createPaymentShareMembersSpentAmount:
    documentCreators.createPaymentShareMembersSpentAmount,
  createPaymentShareInterest: documentCreators.createPaymentShareInterest,
  createEnterpriseBillingAgreementBalance:
    documentCreators.createEnterpriseBillingAgreementBalance,
  createMembershipSubscriptionHistory:
    documentCreators.createMembershipSubscriptionHistory,
  createMembershipPackages: documentCreators.createMembershipPackages,
  createMembershipTrials: documentCreators.createMembershipTrials,
  createMembershipRenewals: documentCreators.createMembershipRenewals,
  createMembershipDowngrade: documentCreators.createMembershipDowngrade,
  createUserInteraction: documentCreators.createUserInteraction,
  createVerificationAddressDocumentTypes:
    documentCreators.createVerificationAddressDocumentTypes,
  createVerificationFiles: documentCreators.createVerificationFiles,
  createVerificationIdTypes: documentCreators.createVerificationIdTypes,
  createVerificationRequest: documentCreators.createVerificationRequest,
  createVerificationCorporateKyc:
    documentCreators.createVerificationCorporateKyc,
  createQuotationRevision: documentCreators.createQuotationRevision,
  createQuotationItemRevision: documentCreators.createQuotationItemRevision,
  createQuotationItemRevisions: documentCreators.createQuotationItemRevisions,
  createQuotationLogo: documentCreators.createQuotationLogo,
  createUserNotificationPreferences:
    documentCreators.createUserNotificationPreferences,
  createNotificationSettings: documentCreators.createNotificationSettings,
  createUserSettings: documentCreators.createUserSettings,
  createTaxOptOutOptionObjects: documentCreators.createTaxOptOutOptionObjects,
  createTimezones: documentCreators.createTimezones,
  createUsStates: documentCreators.createUsStates,
  createCountryStates: documentCreators.createCountryStates,
  createLanguages: documentCreators.createLanguages,
  createPjpDraft: documentCreators.createPjpDraft,
  createPredefinedDiscoverCollection:
    documentCreators.createPredefinedDiscoverCollection,
  createManageViewContestHandovers:
    documentCreators.createManageViewContestHandovers,
  createManageViewContestHandover:
    documentCreators.createManageViewContestHandover,
  createManageViewContest: documentCreators.createManageViewContest,
  createDiscoverCollectionItem: documentCreators.createDiscoverCollectionItem,
  createCampaign: documentCreators.createCampaign,
  createServiceOffering: documentCreators.createServiceOffering,
  createServiceOfferingWithOwnerDetails:
    documentCreators.createServiceOfferingWithOwnerDetails,
  createServiceOfferingBuyerHistories:
    documentCreators.createServiceOfferingBuyerHistories,
  createServiceOfferingShop: documentCreators.createServiceOfferingShop,
  createServiceOfferingCategories:
    documentCreators.createServiceOfferingCategories,
  createServiceOfferingShopCategoryService:
    documentCreators.createServiceOfferingShopCategoryService,
  createVerificationProcessType: documentCreators.createVerificationProcessType,
  createVerificationProcessTypes:
    documentCreators.createVerificationProcessTypes,
  createUserDocumentSubmission: documentCreators.createUserDocumentSubmission,
  createUserVerificationProcesses:
    documentCreators.createUserVerificationProcesses,
  createSearchActiveLoad: documentCreators.createSearchActiveLoad,
  createSearchActiveLoads: documentCreators.createSearchActiveLoads,
  createOperatingAreaRegions: documentCreators.createOperatingAreaRegions,
  createLoadTypes: documentCreators.createLoadTypes,
  createRecommendedUserNames: documentCreators.createRecommendedUserNames,
  createRecommendedMembership: documentCreators.createRecommendedMembership,
  createUserDocumentSubmissions: documentCreators.createUserDocumentSubmissions,
  createAdminUserDocumentSubmissions:
    documentCreators.createAdminUserDocumentSubmissions,
  createShowcase: documentCreators.createShowcase,
  createShowcases: documentCreators.createShowcases,
  createHirePageDetails: documentCreators.createHirePageDetails,
  createBillingAgreements: documentCreators.createBillingAgreements,
  createTaxStatements: documentCreators.createTaxStatements,
  createBidPitch: documentCreators.createBidPitch,
  createIpContract: documentCreators.createIpContract,
  createAnalytics: documentCreators.createAnalytics,
  createPayoutLimitExemptions: documentCreators.createPayoutLimitExemptions,
  createManageViewOpenProject: documentCreators.createManageViewOpenProject,
  createManageViewPastBids: documentCreators.createManageViewPastBids,
  createManageViewPastProjects: documentCreators.createManageViewPastProjects,
  createManageViewPastProject: documentCreators.createManageViewPastProject,
  createManageViewOpenProjects: documentCreators.createManageViewOpenProjects,
  createReferralInvitations: documentCreators.createReferralInvitations,
  createReferralRecords: documentCreators.createReferralRecords,
  createGuideline: documentCreators.createGuideline,
  createProfile: documentCreators.createProfile,
  createProfiles: documentCreators.createProfiles,
  createDiscoverCollectionItemSaveCounts:
    documentCreators.createDiscoverCollectionItemSaveCounts,
  createSuperuserProjectNotes: documentCreators.createSuperuserProjectNotes,
  createIsLookingForWork: documentCreators.createIsLookingForWork,
  createRecurringBillingInformation:
    documentCreators.createRecurringBillingInformation,
  createScheduledSubscriptionPayment:
    documentCreators.createScheduledSubscriptionPayment,
  createRecurringBillingInformations:
    documentCreators.createRecurringBillingInformations,
  createScheduledSubscriptionPayments:
    documentCreators.createScheduledSubscriptionPayments,
  createSubscriptionItem: documentCreators.createSubscriptionItem,
  createSubscriptionItems: documentCreators.createSubscriptionItems,
  createProjectSeo: documentCreators.createProjectSeo,
  createUserFollows: documentCreators.createUserFollows,
  createPreferredSupportAgentAssignments:
    documentCreators.createPreferredSupportAgentAssignments,
  createIrisOffsitingMessages: documentCreators.createIrisOffsitingMessages,
  createCheckInSchedule: documentCreators.createCheckInSchedule,
  createSkillsSubNavigation: documentCreators.createSkillsSubNavigation,
  createExternalReference: documentCreators.createExternalReference,
  createFindPageDetails: documentCreators.createFindPageDetails,
  createFlareCheckpoint: documentCreators.createFlareCheckpoint,
  createFlareRule: documentCreators.createFlareRule,
  createFlareRuleset: documentCreators.createFlareRuleset,
  createFlareActionMap: documentCreators.createFlareActionMap,
  createFlareAdminLog: documentCreators.createFlareAdminLog,
  createSupportAnswer: documentCreators.createSupportAnswer,
  createCanvas: documentCreators.createCanvas,
  createSearchPreferredFreelancers:
    documentCreators.createSearchPreferredFreelancers,
  createChallenges: documentCreators.createChallenges,
  createSwiftIdOccupations: documentCreators.createSwiftIdOccupations,
  createSwiftIdSourcesOfWealth: documentCreators.createSwiftIdSourcesOfWealth,
  createSwiftIdIndustries: documentCreators.createSwiftIdIndustries,
  createSwiftIdInvitation: documentCreators.createSwiftIdInvitation,
  createSwiftIdNatureOfBusiness: documentCreators.createSwiftIdNatureOfBusiness,
  createSwiftIdSourcesOfFunds: documentCreators.createSwiftIdSourcesOfFunds,
  createSwiftIdApplication: documentCreators.createSwiftIdApplication,
  createSwiftIdCompanyApplication:
    documentCreators.createSwiftIdCompanyApplication,
  createSwiftIdApplicationStatus:
    documentCreators.createSwiftIdApplicationStatus,
  createSwiftIdApplicant: documentCreators.createSwiftIdApplicant,
  createSupportViewDetails: documentCreators.createSupportViewDetails,
  createSupportCategories: documentCreators.createSupportCategories,
  createSupportCategoryArticles: documentCreators.createSupportCategoryArticles,
  createSupportArticles: documentCreators.createSupportArticles,
  createSearchArticles: documentCreators.createSearchArticles,
  createPartialSearchArticles: documentCreators.createPartialSearchArticles,
  createSupportSuggestedArticles:
    documentCreators.createSupportSuggestedArticles,
  createSupportIssueCategoryArticles:
    documentCreators.createSupportIssueCategoryArticles,
  createSupportIssueCategories: documentCreators.createSupportIssueCategories,
  createSupportChat: documentCreators.createSupportChat,
  createSupportSessionNote: documentCreators.createSupportSessionNote,
  createOnboardingEmailChangeEligibility:
    documentCreators.createOnboardingEmailChangeEligibility,
  createBusinessBuilderAttempt: documentCreators.createBusinessBuilderAttempt,
  createPrototyperPermissions: documentCreators.createPrototyperPermissions,
  createAdminProfileHistory: documentCreators.createAdminProfileHistory,
  createModifyBidSellerFees: documentCreators.createModifyBidSellerFees,
  createCountryRequiresWhatsapp: documentCreators.createCountryRequiresWhatsapp,
  createContestHandoverDispute: documentCreators.createContestHandoverDispute,
  createRegisteredUserLookup: documentCreators.createRegisteredUserLookup,
  addPushTransformers: pushTransformers.addPushTransformers,
  noop: pushTransformers.noop,
  addGeneratedNumericalId: pushTransformers.addGeneratedNumericalId,
  addGeneratedStringId: pushTransformers.addGeneratedStringId,
  addContestComputedFields: pushTransformers.addContestComputedFields,
  addProjectViewBidComputedFields:
    pushTransformers.addProjectViewBidComputedFields,
  addProjectViewProjectComputedFields:
    pushTransformers.addProjectViewProjectComputedFields,
  addProfilesComputedFields: pushTransformers.addProfilesComputedFields,
  addProjectCollaborationComputedFields:
    pushTransformers.addProjectCollaborationComputedFields,
  addInvitationComputedFields: pushTransformers.addInvitationComputedFields,
  addLoadPriceEstimateComputedFields:
    pushTransformers.addLoadPriceEstimateComputedFields,
  addGroupsComputedFields: pushTransformers.addGroupsComputedFields,
  addSuperuserGroupsComputedFields:
    pushTransformers.addSuperuserGroupsComputedFields,
  addInvitationBlockComputedFields:
    pushTransformers.addInvitationBlockComputedFields,
  addExperienceComputedFields: pushTransformers.addExperienceComputedFields,
  addEducationComputedFields: pushTransformers.addEducationComputedFields,
  addPublicationComputedFields: pushTransformers.addPublicationComputedFields,
  addCertificationComputedFields:
    pushTransformers.addCertificationComputedFields,
  addReviewComputedFields: pushTransformers.addReviewComputedFields,
  addContestCommentComputedFields:
    pushTransformers.addContestCommentComputedFields,
  addPaymentShareMemberComputedFields:
    pushTransformers.addPaymentShareMemberComputedFields,
  addPaymentShareInterestsComputedFields:
    pushTransformers.addPaymentShareInterestsComputedFields,
  addGroupMember: pushTransformers.addGroupMember,
  addAdminChargeUserFeeComputedFields:
    pushTransformers.addAdminChargeUserFeeComputedFields,
  addStartAiServiceChatComputedFields:
    pushTransformers.addStartAiServiceChatComputedFields,
  addAdminEnterprisesComputedFields:
    pushTransformers.addAdminEnterprisesComputedFields,
  addAdminPcbBanManagementComputedFields:
    pushTransformers.addAdminPcbBanManagementComputedFields,
  addAdminUserEnterprisesComputedFields:
    pushTransformers.addAdminUserEnterprisesComputedFields,
  addProjectTitleEditRequestComputedFields:
    pushTransformers.addProjectTitleEditRequestComputedFields,
  addSearchSavedFiltersComputedFields:
    pushTransformers.addSearchSavedFiltersComputedFields,
  addMembershipRenewalsComputedFields:
    pushTransformers.addMembershipRenewalsComputedFields,
  addUserTaxInfoComputedFields: pushTransformers.addUserTaxInfoComputedFields,
  addQuotationRevision: pushTransformers.addQuotationRevision,
  addQuotationItemRevision: pushTransformers.addQuotationItemRevision,
  addQuotationLogoComputedFields:
    pushTransformers.addQuotationLogoComputedFields,
  addVerificationRequestComputedFields:
    pushTransformers.addVerificationRequestComputedFields,
  addDiscoverCollectionItem: pushTransformers.addDiscoverCollectionItem,
  addCartApprovalComputedFields: pushTransformers.addCartApprovalComputedFields,
  addContestRubricComputedFields:
    pushTransformers.addContestRubricComputedFields,
  addContestRubricSubmissionComputedFields:
    pushTransformers.addContestRubricSubmissionComputedFields,
  addContestEntryJudgeAssignmentComputedFields:
    pushTransformers.addContestEntryJudgeAssignmentComputedFields,
  addContestEntryOfferComputedFields:
    pushTransformers.addContestEntryOfferComputedFields,
  addUserAvailabilityComputedFields:
    pushTransformers.addUserAvailabilityComputedFields,
  addServiceOfferingComputedFields:
    pushTransformers.addServiceOfferingComputedFields,
  addServiceOfferingAttachmentComputedFields:
    pushTransformers.addServiceOfferingAttachmentComputedFields,
  addServiceOfferingShopCategoryComputedFields:
    pushTransformers.addServiceOfferingShopCategoryComputedFields,
  addServiceOfferingShopCategoryServiceFields:
    pushTransformers.addServiceOfferingShopCategoryServiceFields,
  addPostJobPageQuestionsComputedFields:
    pushTransformers.addPostJobPageQuestionsComputedFields,
  addPostJobPageDescriptionComputedFields:
    pushTransformers.addPostJobPageDescriptionComputedFields,
  addTaxStatementFields: pushTransformers.addTaxStatementFields,
  addPayoutAccount: pushTransformers.addPayoutAccount,
  addUsersRecommend: pushTransformers.addUsersRecommend,
  addPayoutLimitExemptionComputedFields:
    pushTransformers.addPayoutLimitExemptionComputedFields,
  addProjectOfferComputedFields: pushTransformers.addProjectOfferComputedFields,
  addBidDescriptionGenerationComputedFields:
    pushTransformers.addBidDescriptionGenerationComputedFields,
  addShowCaseComputedFields: pushTransformers.addShowCaseComputedFields,
  addFreeRecruiterUpgradeComputedFields:
    pushTransformers.addFreeRecruiterUpgradeComputedFields,
  addMilestoneDraftsComputedFields:
    pushTransformers.addMilestoneDraftsComputedFields,
  addNextProjectRecommendationsComputedFields:
    pushTransformers.addNextProjectRecommendationsComputedFields,
  addAgentSessionsComputedFields:
    pushTransformers.addAgentSessionsComputedFields,
  addEnterprisesComputedFields: pushTransformers.addEnterprisesComputedFields,
  addContactUsFields: pushTransformers.addContactUsFields,
  addUserDocumentSubmissions: pushTransformers.addUserDocumentSubmissions,
  addUserVerificationProcesses: pushTransformers.addUserVerificationProcesses,
  addHarvardContactFields: pushTransformers.addHarvardContactFields,
  addUnconfirmedAwardsFields: pushTransformers.addUnconfirmedAwardsFields,
  addCustomBannerComputedFields: pushTransformers.addCustomBannerComputedFields,
  addContestEntriesFields: pushTransformers.addContestEntriesFields,
  addContestFilesComputedFields: pushTransformers.addContestFilesComputedFields,
  addContestHandoverFileComputedFields:
    pushTransformers.addContestHandoverFileComputedFields,
  addContractSigningUrlComputedFields:
    pushTransformers.addContractSigningUrlComputedFields,
  addRecommendedUpgradeComputedFields:
    pushTransformers.addRecommendedUpgradeComputedFields,
  addSavedSearchContextComputedFields:
    pushTransformers.addSavedSearchContextComputedFields,
  addProjectGroupComputedFields: pushTransformers.addProjectGroupComputedFields,
  addCategoryComputedFields: pushTransformers.addCategoryComputedFields,
  addRecurringBillingInformationComputedFields:
    pushTransformers.addRecurringBillingInformationComputedFields,
  addAiConsultantComputedFields: pushTransformers.addAiConsultantComputedFields,
  addSalesTaxComputedFields: pushTransformers.addSalesTaxComputedFields,
  addCopilotEnquiryFields: pushTransformers.addCopilotEnquiryFields,
  addPreferredSupportAgentFields:
    pushTransformers.addPreferredSupportAgentFields,
  addContinueWritingFields: pushTransformers.addContinueWritingFields,
  addImproveWritingFields: pushTransformers.addImproveWritingFields,
  addProofreadFields: pushTransformers.addProofreadFields,
  addAiChangeToneFields: pushTransformers.addAiChangeToneFields,
  addIrisOffsitingMessageFields: pushTransformers.addIrisOffsitingMessageFields,
  addExternalReferenceFields: pushTransformers.addExternalReferenceFields,
  addProjectDescriptionInsertionsFields:
    pushTransformers.addProjectDescriptionInsertionsFields,
  addProjectDescriptionEntropyQuestionFields:
    pushTransformers.addProjectDescriptionEntropyQuestionFields,
  addProjectDescriptionEntropyCompletionFields:
    pushTransformers.addProjectDescriptionEntropyCompletionFields,
  addSupportAnswerFields: pushTransformers.addSupportAnswerFields,
  addFinancialReportingRecordComputedFields:
    pushTransformers.addFinancialReportingRecordComputedFields,
  addCanvasComputedFields: pushTransformers.addCanvasComputedFields,
  addEnterpriseContactComputedFields:
    pushTransformers.addEnterpriseContactComputedFields,
  addAiPromptPreviewFields: pushTransformers.addAiPromptPreviewFields,
  addAiPrompts: pushTransformers.addAiPrompts,
  addSwiftIdApplicationComputedFields:
    pushTransformers.addSwiftIdApplicationComputedFields,
  addSwiftIdApplicationStatusComputedFields:
    pushTransformers.addSwiftIdApplicationStatusComputedFields,
  addSwiftIdInvitationComputedFields:
    pushTransformers.addSwiftIdInvitationComputedFields,
  addProjectSkillsPredictionFields:
    pushTransformers.addProjectSkillsPredictionFields,
  addRetellPhoneCallComputedFields:
    pushTransformers.addRetellPhoneCallComputedFields,
  addSupportArticleFeedbacks: pushTransformers.addSupportArticleFeedbacks,
  addSupportChat: pushTransformers.addSupportChat,
  addSupportSessionNoteComputedFields:
    pushTransformers.addSupportSessionNoteComputedFields,
  addUserConsentComputedFields: pushTransformers.addUserConsentComputedFields,
  addUserNetPromoterScore: pushTransformers.addUserNetPromoterScore,
  addOnboardingEmailChangeComputedFields:
    pushTransformers.addOnboardingEmailChangeComputedFields,
  addRetellTokenComputedFields: pushTransformers.addRetellTokenComputedFields,
  addRetellProjectDetailsComputedFields:
    pushTransformers.addRetellProjectDetailsComputedFields,
  addAdminExternalCredentialAllocationComputedFields:
    pushTransformers.addAdminExternalCredentialAllocationComputedFields,
  addPrototyperPermissionComputedFields:
    pushTransformers.addPrototyperPermissionComputedFields,
  addRmpjpReviewStepChatResponse:
    pushTransformers.addRmpjpReviewStepChatResponse,
  addTimeTrackingSessionComputedFields:
    pushTransformers.addTimeTrackingSessionComputedFields,
  addSupportChatBlockComputedFields:
    pushTransformers.addSupportChatBlockComputedFields,
  addContestHandoverDisputeComputedFields:
    pushTransformers.addContestHandoverDisputeComputedFields,
};
